// extracted by mini-css-extract-plugin
module.exports = {"container":"_error_container__b3YeW","description":"_error_description__h534W"};